// extracted by mini-css-extract-plugin
module.exports = {"container":"_2IdCH7Zj_R6aXt6MKFLc41"};